var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { FunnelIcon } from '@heroicons/react/24/solid';
import { Translate, t } from "../../../../../I18N";
import { Pill, Button } from "../../../../Components/UI";

import {
  DatePropertyIcon,
  MarkdownPropertyIcon,
  NumericPropertyIcon,
  TextPropertyIcon } from "../../../../Components/CustomIcons";


const SuggestionsTitle = ({
  property,
  templates,
  onFiltersButtonClicked




}) => {var _templates$;
  const allProperties = [...(templates[0].commonProperties || []), ...templates[0].properties];
  const template = allProperties.find((prop) => prop.name === property);

  let propGraphics = '_';

  switch (template === null || template === void 0 ? void 0 : template.type) {
    case 'date':
      propGraphics = /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-3" });
      break;
    case 'numeric':
      propGraphics = /*#__PURE__*/_jsx(NumericPropertyIcon, { className: "w-3" });
      break;
    case 'markdown':
      propGraphics = /*#__PURE__*/_jsx(MarkdownPropertyIcon, { className: "w-3" });
      break;
    default:
      propGraphics = /*#__PURE__*/_jsx(TextPropertyIcon, { className: "w-3" });
  }

  return /*#__PURE__*/(
    _jsx("div", { className: "flex gap-4" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-wrap gap-2 content-center grow" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "flex justify-center items-center w-7 h-7 font-sans text-sm text-center text-gray-700 bg-indigo-200 rounded-full" }, void 0,
    propGraphics
    ), /*#__PURE__*/
    _jsx("span", {}, void 0, t((_templates$ = templates[0]) === null || _templates$ === void 0 ? void 0 : _templates$._id, template === null || template === void 0 ? void 0 : template.label, null, false)), /*#__PURE__*/
    _jsx("span", { className: "italic font-normal" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "for")
    ),
    templates.map((templateToDisplay) => /*#__PURE__*/
    _jsx(Pill, {
      color: "gray",
      className: "inline-flex items-center text-xs font-medium whitespace-nowrap" },
    templateToDisplay._id,

    templateToDisplay.name
    )
    )
    ), /*#__PURE__*/

    _jsx("div", { className: "flex-none" }, void 0, /*#__PURE__*/
    _jsx(Button, { size: "small", styling: "light", onClick: onFiltersButtonClicked }, void 0, /*#__PURE__*/
    _jsx(FunnelIcon, { className: "inline px-1 w-5 text-gray-800" }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Stats & Filters")
    )
    )
    ));

};

export { SuggestionsTitle };